import React, { Component } from 'react';
import './App.css';

//Redux
import { Provider } from 'react-redux';
import { Store } from './redux/store';

import Routes from './Routes';
import {IntlProvider} from 'react-intl';





class App extends Component {

  componentDidMount = () => {
    
  }



  render() {
    return (
      
        <Provider store={Store}>
          <IntlProvider locale="pt">
          <React.Fragment>
            
              <Routes>

              </Routes>
            
          </React.Fragment>
          </IntlProvider>
        </Provider>
      
    );
  }
}

export default App;
